module.exports = __webpack_public_path__ + "img/booking-light.f88b3722.svg";